import { withStyles } from "@material-ui/core/styles";
import "date-fns";
import "fontsource-roboto";
import $ from "jquery";
import {
  Paper,
  Grid,
  Card,
  CardContent,
  Typography,
  Link,
  Divider,
  Zoom,
} from "@material-ui/core";
import React, { Component } from "react";
import { formateDate, getQueryVariable } from "../utils/utilTools";
import Pagination from "@material-ui/lab/Pagination";
import { VideoLibrary, InsertLink, FindInPage } from "@material-ui/icons";
import SearchNoResult from "./search-noResult";
import PagepreDis from "./pagepre-dis";
import Pagenext from "./pagenext";
import Pagepre from "./pagepre";
import PagenextDis from "./pagenext-dis";

require("../assets/css/style.css");
require("../assets/css/news-style.css");
const imageAccount = require("../assets/images/top-ico1.png");
const searchTitle = require("../assets/images/gw.png");

const useStyles = {
  root: {
    "& > *": {
      width: "65ch",
    },
  },
  inputText: {
    padding: "0 5px 0 0",
  },
  breakLine: {
    margin: "20px 0 0 0",
  },
  breakLineInset: {
    margin: "20px 0 0 16px",
  },
};

class SearchNews extends Component {
  constructor(props) {
    super();
    this.state = {
      selectedDate: new Date(),
      checked: false,
    };
  }

  componentWillUnmount = () => {
    this.setState = (state, callback) => {
      return;
    };
  };
  componentWillReceiveProps(prop) {
    this.setState({
      checked: prop.results && prop.results.length > 0,
    });
  }

  componentDidMount() {
    // 删除分页的数字按钮
  }

  componentDidCatch(error, errorInfo) {
    console.log("==============", error, errorInfo);
  }

  render() {
    const _state = this.state;
    const {
      setHotInfo,
      pageNum,
      handlePaging,
      pages,
      results,
      showLoading,
    } = this.props;

    const loading = <div className="loader"> </div>;

    let contents = [];
    contents =
      results && results.length > 0 ? (
        results.map((value, index) => (
          <Zoom
            in={_state.checked}
            style={{ transformOrigin: "0 0 0" }}
            {...(_state.checked > 0 ? { timeout: index * 500 } : {})}
          >
            <Card className="news-content-card" key={index}>
              <CardContent className="news-content-card-class">
                <button
                  class="draw"
                  onClick={() => {
                    window.open(value.url);
                    setHotInfo(value.url, value.title);
                  }}
                >
                  {value.catalogname ? (
                    <span className="tag">{value.catalogname}</span>
                  ) : (
                    ""
                  )}
                  <Typography variant="h5" component="h2">
                    <Link
                      // onClick={this.setHotInfo.bind(this)}
                      className="search-result-title"
                      title={value.title}
                      href={value.url}
                      target="_blank"
                      variant="body2"
                      dangerouslySetInnerHTML={{
                        __html: value.titleN ? value.titleN : value.title,
                      }}
                    ></Link>
                    &emsp;
                    {!value.catalogname ? (
                      ""
                    ) : value.catalogname.indexOf("视频") >= 0 ? (
                      <div className="title-icon">
                        <VideoLibrary style={{ color: "#f0b755" }} />
                      </div>
                    ) : value.catalogname.indexOf("国务院") >= 0 ||
                      value.catalogname.indexOf("江苏") >= 0 ? (
                      <div className="title-icon">
                        <InsertLink style={{ color: "#f0b755" }} />
                      </div>
                    ) : (
                      ""
                    )}
                    {/* &emsp;
                <span className="date-class">
                  发布时间：{formateDate(value.showtime)}
                </span> */}
                  </Typography>
                  <Typography component="p">
                    <div className="abstract-heigth-class">
                      <span
                        dangerouslySetInnerHTML={{
                          __html: value.json ? value.json : value.title,
                        }}
                      ></span>
                    </div>
                    <div>
                      <span className="date-class">
                        发布时间：{formateDate(value.showtime)}
                      </span>
                    </div>
                  </Typography>
                </button>
              </CardContent>
              <Divider />
            </Card>
          </Zoom>
        ))
      ) : (
        <div className="content-class" style={{ textAlign: "center" }}>
          <SearchNoResult />
        </div>
      );

    //   <div className="content-class" style={{ textAlign: "center" }}>
    //   <SearchNoResult />
    // </div>

    return (
      <Grid container spacing={1}>
        {/* <Grid className="news-icon-class" item xs={1}>
          <img src={require("../assets/images/newsicon.png")} style={{width: "35px"}}/>
        </Grid> */}
        {/* <Grid className="news-title-p" item xs={11}>
          <p className="news-title">新闻动态</p>
          <div className="bottom-border"></div>
        </Grid> */}
        <Grid item xs={12}>
          {showLoading ? (
            loading
          ) : (
            <div>
              <Paper elevation={0}>
                <div className="news-list">{contents}</div>
              </Paper>
              {contents.length > 0 ? (
                // <div className="page-class">
                //   <div
                //     onClick={pageNum === 1 ? "" : () => handlePaging(true)}
                //     style={{ display: "inline-block" }}
                //   >
                //     {pageNum === 1 ? <PagepreDis /> : <Pagepre classname="page-news-back"/>}
                //   </div>
                //   <div
                //     onClick={pageNum === pages ? "" : () => handlePaging(false)}
                //     style={{ display: "inline-block" }}
                //   >
                //     {pageNum === pages ? <PagenextDis /> : <Pagenext classname="page-news-back"/>}
                //   </div>
                // </div>
                <Pagination
                  className="page-class"
                  size="medium"
                  shape="rounded"
                  count={pages}
                  page={pageNum}
                  onChange={handlePaging}
                />
              ) : (
                ""
              )}
            </div>
          )}
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(useStyles)(SearchNews);
